import { useEffect } from "react";
import { validate as validateUuid } from 'uuid';

import { useTypedSelector } from "store/reducers/use-typed-selector";
import { deregister } from "./deregister";

const useClearStorageRedirect = () => {
	const eventBundle = useTypedSelector(state => state.LiveEventReducer?.eventBundle);
	const eventUuid = eventBundle?.uuid;
	const registrationOn = eventBundle?.registration_on;
	const reduxToken = useTypedSelector(state => state.LiveEventReducer.blProfileUserToken);

	useEffect(() => {
		if (!registrationOn || !eventBundle) return;

		const handleStorageMessage = (event: StorageEvent) => {
			const key = event.key;

			// if user clears all storage, key will be null
			if (key === null && event.newValue === null) {
				deregister(eventBundle);
				return;
			}

			// if one of THIS event's profile tokens is removed in another tab, deregister.
			// Keyed per-event so that token churn on a SIBLING series event (same origin,
			// shared localStorage) does not log this tab out — only the matching event's
			// token removal triggers a logout here.
			if (
				key &&
				eventUuid &&
				[
					`Bl-Profile-Token.${eventUuid}`,
					`bl-profile.${eventUuid}`,
				].includes(key)
			) {
				const item = getParsedItem(event.newValue);
				if (!item) {
					deregister(eventBundle);
					return;
				}
			}
		};

		window.addEventListener('storage', handleStorageMessage);

		return () => {
			window.removeEventListener('storage', handleStorageMessage);
		};
	}, [registrationOn, eventUuid, eventBundle, reduxToken]);
};

export default useClearStorageRedirect;


const getParsedItem = (value: string | null): string | null => {
	if (!value) return null;
	try {
		const parsed = JSON.parse(value);
		if (!('item' in parsed)) return null;
		return parsed.item;
	} catch {
		return null;
	}
};
